export const FETCH_DASHBOARDS_REQUEST = "dashboard/FETCH_DASHBOARDS_REQUEST";
export const FETCH_DASHBOARDS_SUCCESS = "dashboard/FETCH_DASHBOARDS_SUCCESS";
export const FETCH_DASHBOARDS_FAILURE = "dashboard/FETCH_DASHBOARDS_FAILURE";

export const FETCH_COMPANY_CONFIG_REQUEST = "dashboard/FETCH_COMPANY_CONFIG_REQUEST";
export const FETCH_COMPANY_CONFIG_SUCCESS = "dashboard/FETCH_COMPANY_CONFIG_SUCCESS";
export const FETCH_COMPANY_CONFIG_FAILURE = "dashboard/FETCH_COMPANY_CONFIG_FAILURE";

export const fetchDashboardsRequest = () => ({ type: FETCH_DASHBOARDS_REQUEST });
export const fetchDashboardsSuccess = (data) => ({ type: FETCH_DASHBOARDS_SUCCESS, payload: { data } });
export const fetchDashboardsFailure = (error) => ({ type: FETCH_DASHBOARDS_FAILURE, payload: { error } });

export const fetchCompanyConfigRequest = (companyId) => ({
  type: FETCH_COMPANY_CONFIG_REQUEST,
  payload: { companyId },
});
export const fetchCompanyConfigSuccess = (data) => ({
  type: FETCH_COMPANY_CONFIG_SUCCESS,
  payload: { data },
});
export const fetchCompanyConfigFailure = (error) => ({
  type: FETCH_COMPANY_CONFIG_FAILURE,
  payload: { error },
});

export const UPDATE_COMPANY_CONFIG_REQUEST = "dashboard/UPDATE_COMPANY_CONFIG_REQUEST";
export const UPDATE_COMPANY_CONFIG_SUCCESS = "dashboard/UPDATE_COMPANY_CONFIG_SUCCESS";
export const UPDATE_COMPANY_CONFIG_FAILURE = "dashboard/UPDATE_COMPANY_CONFIG_FAILURE";

export const updateCompanyConfigRequest = (companyId, patch) => ({
  type: UPDATE_COMPANY_CONFIG_REQUEST,
  payload: { companyId, patch },
});
export const updateCompanyConfigSuccess = (data) => ({
  type: UPDATE_COMPANY_CONFIG_SUCCESS,
  payload: { data },
});
export const updateCompanyConfigFailure = (error) => ({
  type: UPDATE_COMPANY_CONFIG_FAILURE,
  payload: { error },
});
